<script>
    import button from './ib-button.vue'

    /**
    * A button used explicitly with vue-router to go back one state.
    **/
    export default {
        name: 'ib-button-back',
        mixins: [button],

        methods: {
            _click(e) {
                this.$router.go(-1);
            }
        }
    }
</script>

<docs>
    ```jsx
        <div>
            <p>Functionality only - this just wraps a button. Don't actually click this, it doesn't do anything here.</p>
            <ib-button-back>Previous</ib-button-back>
        </div>
    ```
</docs>
